import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import CardPaymentForm from "../cardPayment/cardPaymentForm";
import PaymentIntrumentSelection from "../paymentInstrumentSelection/PaymentIntrumentSelection";
import { useSelector } from "react-redux";
import TranslateText from "../../../resuableComponents/TranslateText";
import _ from "lodash";
import { useTranslation } from "react-i18next";

export default function SelectedEmiBankForm({ selectedEmiBank, selectedEmiBankTitle, showCardForm }) {
  const [filteredEmiMethodInfo, setFilteredEmiMethodInfo] = useState([]);
  const emiPaymentDetails = useSelector(state => state.emiCardDetails.emiPaymentDetails)
  const paymentMethodDictionary = useSelector(state => state.paymentSessionDetails?.paymentMethodDictionary)
  const emiPaymentMethod = emiPaymentDetails?.Emi ? emiPaymentDetails.Emi : paymentMethodDictionary?.Emi || []
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedEmiBank && emiPaymentMethod) {
      const filteredMethods = emiPaymentMethod.filter(
        (method) =>
          method.brand === selectedEmiBank.brand &&
          method.emiMethod.issuer === selectedEmiBank.value
      );
      const sortedArray = _.orderBy(filteredMethods, ["emiMethod.duration"], ["asc"]);
      setFilteredEmiMethodInfo(sortedArray);
    }
  }, [selectedEmiBank, emiPaymentMethod]);
  return (
    <>
      {showCardForm && (
        <CardPaymentForm
          paymentType="Emi"
          selectedEmiBankTitle={selectedEmiBankTitle}
          cardType={selectedEmiBank?.brand === "DebitCardEMI" ? "DEBIT" : "CREDIT"} />
      )}
      {/* <Typography className="selectEmiText"><TranslateText label={"SELECT_EMI_PLAN"}>Select EMI plan</TranslateText></Typography> */}
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <PaymentIntrumentSelection
          data={filteredEmiMethodInfo}
        />
      </div>
    </>
  );
}
